import { createUser } from './api';
import { Link } from 'react-router-dom';
import React, { Component, Fragment } from 'react';
import { Mutation } from '@apollo/client/react/components';
import Navbar from '../../../components/Navbar';
import UserForm from '../../../components/UserForm';
import { Loader } from '../../../components/Loader';
import { Modal, Button } from 'react-bootstrap';

class AddUser extends Component {
  formatRoles = (roles, defaultRole) => {
    let applicationUserRoles = roles.map((role) => {
      return role.departments.map((department) => {
        return {
          department: {
            id: department.id,
            Name: department.Name,
          },
          role: {
            id: role.roleId,
            roleType: role.roleType,
          },
          isDefaultRole: defaultRole.roleId === role.roleId && defaultRole.departmentId === department.id ? true : false,
        };
      });
    });
    return applicationUserRoles.reduce((acc, role) => acc.concat(role), []);
  };

  mutationHandler = (formData, mutation) => {
    let applicationUserRoles = this.formatRoles(formData.roles, formData.defaultRole);
    const { user } = formData;
    mutation({
      variables: {
        id: null,
        isDevTeam: false,
        name: user.name,
        adId: user.adId,
        active: user.active,
        mailStop: user.mailStop,
        emailAddress: user.email,
        sendEmail: user.sendEmail,
        applicationUserRoles,
      },
    });
  };

  notifyUser = (loading, data) => {
    if (loading) {
      return (
        <Modal show={true}>
          <Loader title='Updating User' />
        </Modal>
      );
    } else if (data.createUser) {
      return (
        <Modal show={true}>
          <Modal.Header>
            <Modal.Title>User was created.</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h6 className='text-center'>Where would you like to go?</h6>
            <Modal.Footer className='mx-auto'>
              <Button variant='secondary'>
                <Link to='/' style={{ color: 'black' }}>
                  Dashboard
                </Link>
              </Button>
              <Button variant='secondary'>
                <Link to='/Admin/viewUsers' style={{ color: 'black' }}>
                  All Users
                </Link>
              </Button>
            </Modal.Footer>
          </Modal.Body>
        </Modal>
      );
    } else {
      alert('There was an error trying to update this user.');
    }
  };

  render() {
    return (
      <Fragment>
        <Navbar />
        <Mutation mutation={createUser}>
          {(mutation, { loading, data, called }) => (
            <Fragment>
              <UserForm
                title='Create User'
                type={1}
                leftAction={(formData) => this.mutationHandler(formData, mutation)}
                rightAction={() => {}}
                leftText='Create User'
                rightText='Cancel'
              />
              {called ? this.notifyUser(loading, data) : null}
            </Fragment>
          )}
        </Mutation>
      </Fragment>
    );
  }
}

export default AddUser;
